export const faqList = [
    {
        question: 'What is a Rule in Zero Copy CDP?',
        answer: [
            'A rule defines a condition or event that triggers automated data processing or actions to segregate customers to groups. For example, you can create a rule to identify devices of a specific type or customers meeting certain criteria.',
        ],
    },
    {
        question: 'What is the purpose of a Rule Group?',
        answer: [
            'A Rule Group allows you to group one or more conditions that must be true for the rule to trigger.',
            ' Each Rule Group can contain multiple rules (conditions).',
            ' You can add multiple groups to define complex logic using AND/OR relationships.',
        ],
    },
    {
        question: 'What\'s the difference between "Add Rule" and "Add Rule Group"?',
        answer: [
            ' <strong>Add Rule:</strong> Adds another condition within the same group.',
            ' <strong>Add Rule Group:</strong> Creates a new group of conditions, allowing advanced logic (e.g., Group 1 AND Group 2).',
        ],
    },
    {
        question: 'How does the "Aggregator" field work?',
        answer: [
            'The Aggregator lets you apply aggregate logic to your conditions. For example:',
            ' Set the sort order on any specific field ascending/descending.',
            'If aggregation isn\'t needed, you can leave it blank.',
        ],
    },
    {
        question: 'What does "Frequency" mean in the schedule section?',
        answer: [
            'Frequency defines how often the rule runs automatically. Available options typically include:',
            ' <strong>Daily:</strong> Runs once every day.',
            ' <strong>Weekly:</strong> Runs once a week on a specified day.',
            ' <strong>Hourly:</strong> Runs hourly basis (e.g. Half Hourly, Hourly, Every two hour etc.)',
        ],
    },
    {
        question: 'What is the "First Execution Date"?',
        answer: [
            'This is the date when the rule will first execute. If you select the current date, you must set a future Run Time to avoid conflicts.',
        ],
    },
    {
        question: 'What is the difference between "Full" and "Delta" Load Type?',
        answer: [
            ' <strong>Full:</strong> Processes all available data each time the rule runs.',
            ' <strong>Delta:</strong> Processes only the data added or changed since the last execution (if supported by the rule type).',
        ],
    },
    {
        question: 'Why do I see an error when choosing the same-day run time?',
        answer: [
            'If the selected First Execution Date is today, you can only choose a future time for the Schedule Run Time (UTC). This prevents scheduling conflicts for rules that would otherwise trigger immediately.',
        ],
    },
    {
        question: 'What happens after I click "Publish Rule"?',
        answer: [
            'Clicking Publish Rule saves and activates the rule. The system will execute it automatically based on your schedule settings.',
        ],
    },
    {
        question: 'Can I expire a published rule?',
        answer: [
            'Yes. You can go to the Manage Rules section, select the rule, and click on Expire button to stop future executions.',
        ],
    },
    {
        question: 'What\'s the difference between "Publish Rule" and "Save As Draft"?',
        answer: [
            ' <strong>Publish Rule:</strong> Makes the rule active for scheduled execution.',
            ' <strong>Save As Draft:</strong> Saves the rule for review or editing later, without activating it.',
        ],
    },
    {
        question: 'What time zone should I use for scheduling?',
        answer: [
            'All times in the scheduler are shown in UTC time zone. If you\'re operating in a different time zone, make sure to convert your local time to UTC before scheduling.',
        ],
    },
    {
        question: 'Why do I need to provide a Rule Name?',
        answer: [
            'The Rule Name identifies your configuration in the Manage Rules list. Use a clear and descriptive name to make maintenance easier (e.g., PH IQOS Device Trigger).',
        ],
    },
];
